function createSubmitEvent() {
  return new Event('submit', { cancelable: true, bubbles: true });
}

function recaptchaSubmit(form) {
  try {
    // Dispatching submit event for GTM events to fire.
    form.dispatchEvent(createSubmitEvent());
  } finally {
    form.submit();
  }
}

function recaptchaOnLoad() {
  let buttons = document.getElementsByClassName('g-recaptcha');
  Array.from(buttons).forEach((button) => {
    // eslint-disable-next-line no-undef
    grecaptcha.render(button, {
      sitekey: button.getAttribute('data-sitekey'),
      badge: 'bottomleft',
      callback: function() {
        recaptchaSubmit(button.form);
      }
    });
  });
}

// This allows the callback method to call correct function even after bundle.
window.recaptchaOnLoad = recaptchaOnLoad;

let recaptchaScript = document.createElement('script');
recaptchaScript.setAttribute(
  'src',
  'https://www.google.com/recaptcha/api.js?onload=recaptchaOnLoad&render=explicit'
);
recaptchaScript.setAttribute('async', '');
recaptchaScript.setAttribute('defer', '');
document.body.appendChild(recaptchaScript);
